/** Paths/URLs exposed to the SPA for integration launch links (no secrets). */
import { resolveServicePath } from '../config/serviceUrlRegistry';

export interface PublicIntegrationSnapshot {
  nextcloudUserOidcLoginPath: string;
  /** System Admin Services widgets — omit services not in the install profile (e.g. Coturn). */
  installedServices?: string[];
}

export const defaultPublicIntegration: PublicIntegrationSnapshot = {
  nextcloudUserOidcLoginPath: resolveServicePath('nextcloud', 'sso_entry'),
};
